import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import ReactGA from 'react-ga4';
import { initFacebookPixel } from '../../utils/pixel.jsx';


function CookieConsentBanner() {

    const [showPopup, setShowPopup] = useState(false); 
    const [showModal, setShowModal] = useState(false); 
    const [analyticsConsent, setAnalyticsConsent] = useState(true); 

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        const rejected = localStorage.getItem('cookieRejected');

        if (consent === null && rejected === null) {
            setShowPopup(true); 
        } else {
            setShowPopup(false); 
        }
    }, []);

    const handleConsent = () => {
        localStorage.setItem('cookieConsent', 'true');
        localStorage.setItem('analyticsConsent', analyticsConsent ? 'true' : 'false');
        if (analyticsConsent) {
            //document.cookie = "analytics=true; path=/;";
            ReactGA.initialize('G-3ZD3VLX0CN');
            initFacebookPixel();
        }

        setShowPopup(false);
        setShowModal(false);
    };

    const handleReject = () => {
        localStorage.setItem('cookieRejected', 'true'); 
        setShowPopup(false); 
    };

    const handleAnalyticsConsent = (event) => {
        setAnalyticsConsent(event.target.checked);
    };

    return (
        <>
            {/* Footer Pop-up */}
            {showPopup && !showModal && (
                <div className="fixed bottom-0 left-0 right-0 bg-gray-400 text-white p-4 flex flex-col sm:flex-row justify-between items-center shadow-lg z-50">
                    <div className='w-full sm:max-w-[50%] text-sm mb-4 sm:mb-0'>
                        <p>
                            На нашата веб страна користиме колачиња со цел да ви овозможиме најдобро корисничко искуство. Тука можете да ја прочитате
                            <Link to="/privacyPolicy" className='hover:underline text-primary'> Политика за приватност</Link>
                        </p>
                    </div>
                    <div className="flex flex-row sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto">
                        <button
                            className="flex btn btn-outline btn-light btn-sm  sm:w-auto"
                            onClick={handleReject}
                        >
                            Одбивам
                        </button>
                        <button
                            className="flex btn btn-outline btn-primary btn-sm sm:w-auto"
                            onClick={() => handleConsent()}
                        >
                            Прифаќам
                        </button>
                        <button
                            className="flex btn btn-outline btn-info btn-sm  sm:w-auto"
                            onClick={() => setShowModal(true)}
                        >
                            Подесување
                        </button>
                    </div>
                </div>


            )}

            {showModal && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg w-[600px] shadow-lg">
                        <h3 className="text-xl font-semibold">Подесување за колачиња</h3>
                        <p className="mt-2">Ве молиме одберете кои колачиња сакате да ги изберете:</p>

                        <div className="mt-4">
                            <div className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    id="necessaryCookies"
                                    disabled
                                    checked
                                    className="checkbox"
                                />
                                <label htmlFor="necessaryCookies">Неопходни колачиња - мора да бидат овозможени во секое време за нормално функционирање на веб странта</label>
                            </div>

                            <div className="flex items-center space-x-2 mt-4">
                                <input
                                    type="checkbox"
                                    id="analyticsCookies"
                                    checked={analyticsConsent}
                                    onChange={handleAnalyticsConsent}
                                    className="checkbox"
                                />
                                <label htmlFor="analyticsCookies">Аналитички колачиња</label>
                            </div>
                        </div>

                        <div className="mt-6 flex justify-between">
                            <button
                                onClick={() => setShowModal(false)}
                                className="btn btn-outline btn-light btn-sm"
                            >
                                Откажи
                            </button>
                            <button
                                onClick={handleConsent}
                                className="btn btn-secondary btn-sm"
                            >
                                Прифаќам
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}

export default CookieConsentBanner
